export function accTopMenu() {
  const menuItems = document.querySelectorAll(
    ".top-bar-nav .menu-item-has-children > a"
  );

  // Function to close all submenus
  function closeAllSubmenus() {
    document.querySelectorAll(".top-bar-nav .sub-menu").forEach((submenu) => {
      submenu.style.opacity = "0";
      submenu.style.visibility = "hidden"; // Add this for better accessibility
    });
  }

  // Handle focus on the menu items
  menuItems.forEach((item) => {
    item.addEventListener("focus", () => {
      closeAllSubmenus(); // Close all submenus first

      // Open the current submenu
      const submenu = item.nextElementSibling;
      if (submenu && submenu.classList.contains("sub-menu")) {
        submenu.style.opacity = "100%";
        submenu.style.visibility = "visible"; // Make it visible
      }
    });
  });

  // Keep submenu open when navigating inside it
  const subMenus = document.querySelectorAll(".top-bar-nav .sub-menu");
  subMenus.forEach((submenu) => {
    submenu.addEventListener("focusin", () => {
      submenu.style.opacity = "100%";
      submenu.style.visibility = "visible"; // Ensure visibility
    });

    submenu.addEventListener("focusout", () => {
      setTimeout(() => {
        // Only close if focus has moved out of the whole menu
        if (!document.activeElement.closest(".top-bar-nav")) {
          closeAllSubmenus();
        }
      }, 10);
    });
  });

  // Close all submenus when tabbing out of the entire menu
  document.querySelectorAll(".top-bar-nav a").forEach((link) => {
    link.addEventListener("blur", () => {
      setTimeout(() => {
        if (!document.activeElement.closest(".top-bar-nav")) {
          closeAllSubmenus();
        }
      }, 10);
    });
  });
}

export function accPrimaryMenu() {
  const menuItems = document.querySelectorAll(
    ".primary-nav .menu-item-has-children > a"
  );

  // Function to close all submenus
  function closeAllSubmenus() {
    document.querySelectorAll(".primary-nav .sub-menu").forEach((submenu) => {
      submenu.style.opacity = "0";
      submenu.style.visibility = "hidden"; // Hide submenu for accessibility
    });
  }

  // Function to open a specific submenu
  function openSubmenu(submenu) {
    if (submenu && submenu.classList.contains("sub-menu")) {
      submenu.style.opacity = "100%";
      submenu.style.visibility = "visible";
    }
  }

  // Handle focus on the menu items (keyboard navigation)
  menuItems.forEach((item) => {
    item.addEventListener("focus", () => {
      closeAllSubmenus(); // Close all submenus first

      // Open the current submenu
      const submenu = item.nextElementSibling;
      openSubmenu(submenu);
    });
  });

  // Keep the submenu open when navigating inside it
  const subMenus = document.querySelectorAll(".primary-nav .sub-menu");
  subMenus.forEach((submenu) => {
    submenu.addEventListener("focusin", () => {
      openSubmenu(submenu); // Keep the submenu open when focusing inside
    });

    submenu.addEventListener("focusout", () => {
      setTimeout(() => {
        // Only close if focus has moved out of the entire primary navigation menu
        if (!document.activeElement.closest(".primary-nav")) {
          closeAllSubmenus();
        }
      }, 10);
    });
  });

  // Close all submenus when tabbing out of the entire menu
  document.querySelectorAll(".primary-nav a").forEach((link) => {
    link.addEventListener("blur", () => {
      setTimeout(() => {
        if (!document.activeElement.closest(".primary-nav")) {
          closeAllSubmenus();
        }
      }, 10);
    });
  });
}
